import React, { useContext, useEffect, useRef } from 'react';

import useOnClickOutside from 'hooks/click-outside';

import PeopleSearchBar from '../PeopleSearchBar';
import { PeopleSearchContext } from '../PeopleSearchContext';
import { PeopleSearchTabletBackgroundWrapper } from '../styled';
import { PeopleSearchTabletContainer, PeopleSearchTabletWrapper } from './styled';

export default function PeopleSearchTablet() {
  const context = useContext(PeopleSearchContext);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(wrapperRef, () => {
    context.closeTabletSearch();
  });

  useEffect(() => {
    context.setSearchFocused(true);
  }, []);

  return (
    <>
      <PeopleSearchTabletWrapper>
        <PeopleSearchTabletContainer ref={wrapperRef}>
          <PeopleSearchBar />
        </PeopleSearchTabletContainer>
      </PeopleSearchTabletWrapper>
      <PeopleSearchTabletBackgroundWrapper />
    </>
  );
}
